import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";


export {
    GetAllBranches,
    GetSingleField,
    GetBranchesIds,
    UpdateBranch,
    CreateNewBranch,
    DeleteBranch
};

function GetBranchesIds(onSuccess, onError) {

    var headers = getAuthHeader();

    axios
        .get(process.env.VUE_APP_BASE_API_URL + "/custombranchtypes", headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function GetAllBranches(onSuccess, onError) {

    var headers = getAuthHeader();

    axios
        .get(process.env.VUE_APP_BASE_API_URL + "/branches/custombranches" , headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function GetSingleField(fieldId, onSuccess, onError){
    var headers = getAuthHeader();

    axios
        .get(process.env.VUE_APP_BASE_API_URL + "/branches/custombranches/" + fieldId , headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function UpdateBranch(branchToUpdate, onSuccess, onError){
    var headers = getAuthHeader();

    axios
        .put(process.env.VUE_APP_BASE_API_URL + "/branches/custombranches/" + branchToUpdate.id, branchToUpdate , headers)
        .then(() => {
            onSuccess();
        })
        .catch(error => {
            onError(error);
        });
}

function CreateNewBranch(branchToCreate, onSuccess, onError){
    var headers = getAuthHeader();

    axios
        .post(process.env.VUE_APP_BASE_API_URL + "/branches/custombranches", branchToCreate, headers)
        .then(createdBranch => {
            onSuccess(createdBranch.data);
        })
        .catch(error => {
            onError(error);
        });
}

function DeleteBranch(customBranchId, onSuccess, onError){
    var headers = getAuthHeader();

    axios
        .delete(process.env.VUE_APP_BASE_API_URL + "/branches/custombranches/" + customBranchId, headers)
        .then(() => {
            onSuccess();
        })
        .catch(error => {
            onError(error);
        });
}